import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { InputMask } from '@react-input/mask';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';

type Props = ComponentProps<typeof InputMask>;

const StyledMaskedInput = styled(InputMask)`
    font-size: ${FONTS.DESCRIPTION_FONT_SIZE};
    line-height: ${FONTS.DESCRIPTION_FONT_SIZE};
    border-color: ${props => props.theme.background.border};
    border-width: ${STYLES.BORDER_WIDTH};
    border-radius: ${STYLES.BORDER_RADIUS};
    padding: ${STYLES.INPUT_PADDING};
    outline: none;
    box-shadow: none;
    background-color: ${props => props.theme.background.white};
    border-style: solid;
    color: ${props => props.theme.text.black} !important;

    &:hover,
    &:active,
    &:focus {
        color: ${props => props.theme.text.black} !important;
        border-color: ${COLORS.PINK};
        outline: none;
        box-shadow: none;
    }

    ::placeholder {
        color: ${props => props.theme.text.black} !important;
        opacity: 1;
    }

    :-ms-input-placeholder {
        color: ${props => props.theme.text.black} !important;
    }

    ::-ms-input-placeholder {
        color: ${props => props.theme.text.black} !important;
    }
`;

const MaskInput = (props: Props) => <StyledMaskedInput {...props} />;

export default MaskInput;
